import { Phone, Mail, MapPin, Instagram } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="bg-[#0B1C14] text-[#F4F3EF] border-t-2 border-[#0B1C14]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-14 grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-5">
          <div className="flex items-center gap-3">
            <span className="cross-icon" aria-hidden />
            <div className="font-display text-2xl uppercase tracking-tight">
              Crosscut Lawn Care
            </div>
          </div>
          <p className="mt-4 max-w-sm text-sm text-[#F4F3EF]/65 leading-relaxed">
            Locally owned and operated in Traverse City, MI. We bring the
            ballpark home — one stripe at a time.
          </p>
          <a
            data-testid="footer-instagram"
            href="https://www.instagram.com/crosscut.lawncare"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-6 inline-flex items-center gap-3 border-2 border-[#F4F3EF]/20 px-4 py-3 hover:border-[#E64C23] hover:text-[#E64C23] transition-colors group"
          >
            <Instagram size={18} strokeWidth={2.2} />
            <span className="font-mono-accent text-[11px] tracking-[0.22em] uppercase">
              @crosscut.lawncare
            </span>
          </a>
          <p className="mt-6 font-mono-accent text-[10px] tracking-[0.22em] uppercase text-[#F4F3EF]/45">
            &copy; {new Date().getFullYear()} Crosscut Lawn Care · All rights reserved
          </p>
        </div>

        <div className="lg:col-span-3">
          <div className="font-mono-accent text-[10px] tracking-[0.22em] uppercase text-[#E64C23] mb-3">
            Contact
          </div>
          <ul className="space-y-3 text-sm">
            <li className="flex items-center gap-3">
              <Phone size={14} strokeWidth={2.5} />
              <a href="tel:+12314635080" className="hover:text-[#E64C23] transition-colors">
                (231) 463‑5080
              </a>
            </li>
            <li className="flex items-center gap-3 break-all">
              <Mail size={14} strokeWidth={2.5} />
              <a
                href="mailto:crosscutlawntc@gmail.com"
                className="hover:text-[#E64C23] transition-colors"
              >
                crosscutlawntc@gmail.com
              </a>
            </li>
            <li className="flex items-center gap-3">
              <MapPin size={14} strokeWidth={2.5} />
              Traverse City, MI
            </li>
          </ul>
        </div>

        <div className="lg:col-span-4">
          <div className="font-mono-accent text-[10px] tracking-[0.22em] uppercase text-[#E64C23] mb-3">
            Services
          </div>
          <ul className="space-y-2 text-sm">
            <li>Mowing</li>
            <li>Trimming &amp; Edging</li>
            <li>Fertilization</li>
          </ul>
          <a
            data-testid="footer-cta"
            href="#contact"
            className="mt-6 inline-flex items-center gap-2 font-mono-accent text-[11px] tracking-[0.22em] uppercase border-b-2 border-[#E64C23] text-[#E64C23] pb-1 hover:text-white hover:border-white transition-colors"
          >
            Get a free quote →
          </a>
        </div>
      </div>

      <div className="border-t border-[#F4F3EF]/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-4 flex flex-wrap justify-between gap-4 font-mono-accent text-[10px] tracking-[0.22em] uppercase text-[#F4F3EF]/50">
          <span>You grow it… we mow it.</span>
          <span>Christian Brower · Owner</span>
        </div>
      </div>
    </footer>
  );
}
